import BaseRepositoryClass from 'api/utils/BaseRepositoryClass';
import { RepositoryType } from 'api/utils/RepositoryTypes';
import Cookies from 'js-cookie';

type PropsGet = {
    prefix: string;
    url: string;
};

type PropsPut = {
    data: any;
    url: string;
};

export interface CheckoutType {
    payments: Array<{
        methods: {
            [key: string]: {
                code: string;
                name: string;
                description: string;
                instructions: string;
            };
        };
    }>;
    realizationDates: Array<{
        code: string;
        startAt: string;
        endAt: string;
    }>;
    shipments: Array<{
        methods: {
            [key: string]: {
                code: string;
                name: string;
                description: string;
                price: {
                    current: number;
                    currency: string;
                };
            };
        };
    }>;
}

class CheckoutRepository extends BaseRepositoryClass implements RepositoryType {
    token = Cookies.get('X-Authorization');

    get(url: string) {
        return this.requester.get<CheckoutType>(url);
    }

    put({ data, url }: PropsPut) {
        return this.requester.put<any>(`${this.apiVersion}/${url}`, data);
    }
}

export default CheckoutRepository;
